module.exports = __webpack_public_path__ + "static/media/rm_06-05.8d6133bc.png";